module.exports = function () {

    if ($('.iframe-module').length === 0) {
        return;
    }    
        
    var iframes = document.querySelectorAll('.iframe-module iframe');

    iframes.forEach(function (iframe) {
        var observer = new ResizeObserver(entries => {
            for (var entry of entries) {
                if ("aos" in window) {
                    window.aos.refresh();
                }
            }
        });

        observer.observe(iframe);
    });
};